import React from 'react'

export const onClientEntry = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}

export const shouldUpdateScroll = () => {
  return false
}

export const onRouteUpdate = ({ location }) => {
  const hash = location.hash

  // Bez #id zawsze przechodzimy na początek strony
  if (!hash) {
    window.scrollTo(0, 0)
    return
  }

  const id = decodeURIComponent(hash.substring(1))

  // Najpierw ustawiamy stronę na samej górze
  window.scrollTo(0, 0)

  const scrollToElement = () => {
    const element = document.getElementById(id)

    if (!element) {
      return
    }

    const position = element.getBoundingClientRect().top + window.pageYOffset

    const offset = 120

    window.scrollTo({
      top: position - offset,
      behavior: 'smooth',
    })
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(scrollToElement)
  })
}
